import { useQuery, type QueryKey } from '@tanstack/react-query';
import service from '@Service';
import { REPORT_LIST_STALE_MS } from './useShiftReports';
import type {
  TourReportSummary,
  TourReportDetail,
} from '@Types/tourReport';

export const tourReportKeys = {
  forSoul: (soulId: string) => ['tour-reports', 'soul', soulId] as const,
  detail: (id: string) => ['tour-report', id] as const,
};

export function useTourReports({
  soulId,
  enabled = true,
  refetchInterval = false,
}: {
  soulId?: string;
  enabled?: boolean;
  refetchInterval?: number | false;
}) {
  return useQuery<TourReportSummary[]>({
    queryKey: tourReportKeys.forSoul(soulId!) as unknown as QueryKey,
    queryFn: () => service.getTourReports({ soulId: soulId! }),
    enabled: enabled && !!soulId,
    refetchInterval,
    staleTime: REPORT_LIST_STALE_MS,
  });
}

export function useTourReport({
  id,
  enabled = true,
}: {
  id?: string;
  enabled?: boolean;
}) {
  return useQuery<TourReportDetail>({
    queryKey: tourReportKeys.detail(id!) as unknown as QueryKey,
    queryFn: () => service.getTourReport(id!),
    enabled: enabled && !!id,
    // A persisted report never changes; reopening the sheet or refocusing the
    // window must not re-download its email HTML.
    staleTime: Infinity,
  });
}
